import type React from "react";
import { Footer } from "./footer-component";

export const Page = ({
    withNavBar,
    withFooter,
    children,
    style,
}: {
    withNavBar?: boolean;
    withFooter?: boolean;
    children?: React.ReactNode;
    style?: React.CSSProperties;
}) => {
    return (
        <div className={withNavBar === true ? "pt-20" : undefined} style={style}>
            {children}
            {withFooter === true && <Footer />}
        </div>
    );
};
